
export function formatCurrency(number) {
    if (!number && number !== 0)
        return "";
    var isInteger = Math.abs(number % 1) <= (Number.EPSILON * 100);
    if (isInteger)
        return number.toFixed(0);
    else
        return number.toFixed(2);
}